import { render, staticRenderFns } from "./total-spend-category-department-incharge.vue?vue&type=template&id=c9a06746&scoped=true&"
import script from "./total-spend-category-department-incharge.vue?vue&type=script&lang=js&"
export * from "./total-spend-category-department-incharge.vue?vue&type=script&lang=js&"
import style0 from "./total-spend-category-department-incharge.vue?vue&type=style&index=0&id=c9a06746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a06746",
  null
  
)

export default component.exports